export default function PersonalisedAssistance() {
  return (
    <section id="assistance" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-[#C9A961]/10 rounded-full mb-4">
            <span className="text-[#C9A961] text-sm font-semibold">24/7 Support</span>
          </div>
          <h2 className="text-5xl lg:text-6xl font-bold text-[#1A1F2E] mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            Personalised Assistance,<br />Anytime
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Travel shouldn't be complicated. Our expert team is always available to help with every aspect of your journey
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-[#FAF8F5] rounded-2xl p-8 text-center hover:shadow-lg transition-all">
            <div className="w-16 h-16 bg-[#C9A961] rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-calendar-check-line text-2xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#1A1F2E] mb-4">Bookings & Reservations</h3>
            <p className="text-gray-600 leading-relaxed">
              Quick and secure booking process with instant confirmation and detailed itinerary
            </p>
          </div>

          <div className="bg-[#FAF8F5] rounded-2xl p-8 text-center hover:shadow-lg transition-all">
            <div className="w-16 h-16 bg-[#C9A961] rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-refresh-line text-2xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#1A1F2E] mb-4">Cancellations & Modifications</h3>
            <p className="text-gray-600 leading-relaxed">
              Flexible options to change or cancel your bookings with transparent policies
            </p>
          </div>

          <div className="bg-[#FAF8F5] rounded-2xl p-8 text-center hover:shadow-lg transition-all">
            <div className="w-16 h-16 bg-[#C9A961] rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-question-answer-line text-2xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#1A1F2E] mb-4">Travel Guidance</h3>
            <p className="text-gray-600 leading-relaxed">
              Expert advice on destinations, visa requirements, and local customs
            </p>
          </div>
        </div>

        <div className="bg-gradient-to-br from-[#1A1F2E] to-[#2A3F4E] rounded-3xl p-12 lg:p-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <h3 className="text-4xl font-bold mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
                We're Here for You, 24/7
              </h3>
              <p className="text-lg text-white/80 mb-8 leading-relaxed">
                Whether you prefer online bookings or phone assistance, we ensure a smooth, reliable experience built around your needs. Our expert advisors are ready to assist you at any time.
              </p>
              <div className="flex flex-wrap gap-4">
                <button 
                  onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                  className="px-8 py-4 bg-[#C9A961] text-white rounded-lg text-base font-semibold hover:bg-[#B89851] transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-customer-service-2-line text-xl"></i>
                  Talk to an Advisor
                </button>
                <a 
                  href="tel:+442012345678"
                  className="px-8 py-4 bg-white/10 border-2 border-white text-white rounded-lg text-base font-semibold hover:bg-white hover:text-[#1A1F2E] transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-line text-xl"></i>
                  +44 20 1234 5678
                </a>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
                <div className="text-4xl font-bold text-[#C9A961] mb-2">24/7</div>
                <div className="text-white/80 text-sm">Customer Support</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
                <div className="text-4xl font-bold text-[#C9A961] mb-2">1000+</div>
                <div className="text-white/80 text-sm">Happy Families</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
                <div className="text-4xl font-bold text-[#C9A961] mb-2">50+</div>
                <div className="text-white/80 text-sm">Destinations</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
                <div className="text-4xl font-bold text-[#C9A961] mb-2">500+</div>
                <div className="text-white/80 text-sm">Partner Hotels</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
